<template>
  <form class="inscricao-form" @submit.prevent="handleSubmit">
    <div class="form-row">
      <label class="label">Nome completo *</label>
      <input class="input" v-model="form.name" maxlength="120" required @blur="touched.name = true" />
      <span v-if="touched.name && errors.name" class="error-msg">{{ errors.name }}</span>
    </div>

    <div class="form-row form-row-grid">
      <div>
        <label class="label">Idade *</label>
        <input class="input" type="number" min="0" max="120" v-model.number="form.age" required @blur="touched.age = true" />
        <span v-if="touched.age && errors.age" class="error-msg">{{ errors.age }}</span>
      </div>
      <div>
        <label class="label">Telefone</label>
        <input class="input" type="tel" v-model="form.number" placeholder="(11) 99999-0000" />
      </div>
    </div>

    <div class="form-row form-row-grid">
      <div>
        <label class="label">Cidade</label>
        <input class="input" v-model="form.city" />
      </div>
      <div>
        <label class="label">Igreja</label>
        <input class="input" v-model="form.church" />
      </div>
    </div>

    <div class="form-row form-row-grid">
      <div>
        <label class="label">Celula</label>
        <input class="input" v-model="form.celula" />
      </div>
      <div>
        <label class="label">Lider</label>
        <input class="input" v-model="form.leader" />
      </div>
    </div>

    <transition name="fade">
      <div v-if="isMinor" class="form-row minor-section">
        <p class="minor-warning">
          ⚠️ <strong>Voce eh menor de 18.</strong> Preencha os dados do responsavel.
        </p>
        <div class="form-row-grid">
          <div>
            <label class="label">Responsavel *</label>
            <input class="input" v-model="form.responsavel" @blur="touched.responsavel = true" />
            <span v-if="touched.responsavel && errors.responsavel" class="error-msg">{{ errors.responsavel }}</span>
          </div>
          <div>
            <label class="label">Telefone do responsavel *</label>
            <input class="input" type="tel" v-model="form.contatoResponsavel" @blur="touched.contatoResponsavel = true" />
            <span v-if="touched.contatoResponsavel && errors.contatoResponsavel" class="error-msg">{{ errors.contatoResponsavel }}</span>
          </div>
        </div>
      </div>
    </transition>

    <div class="form-row">
      <label class="label">Alergia / Restricao alimentar</label>
      <textarea class="input" v-model="form.allergy" rows="2" maxlength="500" placeholder="Ex: amendoim, gluten..."></textarea>
    </div>

    <div v-if="serverError" class="error-banner">{{ serverError }}</div>

    <button type="submit" class="btn-primary btn-submit" :disabled="submitting || hasErrors">
      <span v-if="submitting">Enviando...</span>
      <span v-else>Confirmar inscricao</span>
    </button>
  </form>
</template>

<script>
export default {
  name: 'InscricaoForm',
  emits: ['submitted', 'closed'],
  props: {
    submitting: { type: Boolean, default: false },
    serverError: { type: String, default: '' }
  },
  data() {
    return {
      form: {
        name: '',
        age: null,
        number: '',
        city: '',
        church: '',
        celula: '',
        leader: '',
        responsavel: '',
        contatoResponsavel: '',
        allergy: ''
      },
      touched: {
        name: false,
        age: false,
        responsavel: false,
        contatoResponsavel: false
      }
    }
  },
  computed: {
    isMinor() {
      return typeof this.form.age === 'number' && this.form.age < 18
    },
    errors() {
      const e = {}
      if (!this.form.name || this.form.name.trim().length < 2) {
        e.name = 'Nome deve ter ao menos 2 caracteres.'
      }
      if (this.form.age === null || this.form.age === '' || Number.isNaN(this.form.age)) {
        e.age = 'Idade obrigatoria.'
      } else if (this.form.age < 0 || this.form.age > 120) {
        e.age = 'Idade invalida.'
      }
      if (this.isMinor) {
        if (!this.form.responsavel?.trim()) e.responsavel = 'Obrigatorio para menores.'
        if (!this.form.contatoResponsavel?.trim()) e.contatoResponsavel = 'Obrigatorio para menores.'
      }
      return e
    },
    hasErrors() { return Object.keys(this.errors).length > 0 }
  },
  methods: {
    touchAll() {
      this.touched = {
        name: true, age: true,
        responsavel: this.isMinor, contatoResponsavel: this.isMinor
      }
    },
    handleSubmit() {
      this.touchAll()
      if (this.hasErrors) return
      const payload = {}
      const fields = ['name', 'age', 'number', 'city', 'church', 'celula', 'leader', 'responsavel', 'contatoResponsavel', 'allergy']
      for (const f of fields) {
        const v = this.form[f]
        if (v === '' || v === null || v === undefined) continue
        payload[f] = typeof v === 'string' ? v.trim() : v
      }
      this.$emit('submitted', payload)
    }
  }
}
</script>

<style scoped>
.inscricao-form {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-base);
}
.form-row { display: flex; flex-direction: column; }
.form-row-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-md);
}
@media (max-width: 480px) {
  .form-row-grid { grid-template-columns: 1fr; }
}
.minor-section {
  padding: var(--spacing-base);
  background: #fff8e1;
  border: 1px solid #f59e0b;
  border-radius: var(--radius-md);
  gap: var(--spacing-md);
}
.minor-warning {
  font-size: var(--text-sm);
  color: #78350f;
  margin-bottom: var(--spacing-md);
}
.error-banner {
  background: #fee2e2;
  color: #b91c1c;
  padding: var(--spacing-md);
  border-radius: var(--radius-md);
  font-size: var(--text-sm);
  font-weight: 500;
}
.btn-submit {
  justify-content: center;
  padding: 14px;
  font-size: var(--text-md);
}
.fade-enter-active, .fade-leave-active { transition: opacity 0.2s; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
</style>
